import { Flex, Switch } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { Attachment } from '@Components/types/Attachment';

import styles from './uploaded-file.module.css';

interface UploadedFileProps {
  uploadedFile?: Attachment;
  showSwitcher?: boolean;
  onUploadedFileRemove?: (value: boolean | undefined) => void;
  handleDownloadClick: () => void;
  shouldRemove: boolean | undefined;
}

export const UploadedFile: React.FC<UploadedFileProps> = ({
  uploadedFile,
  onUploadedFileRemove,
  shouldRemove,
  handleDownloadClick,
  showSwitcher = true,
}) => {
  if (!uploadedFile) {
    return null;
  }

  return (
    <Flex justify="space-between" className={styles.uploadedFile}>
      <div className={styles.linkDownload} onClick={handleDownloadClick}>
        {uploadedFile.name}
      </div>
      {showSwitcher && (
        <div>
          <span className={styles.removeLabel}>Remove</span>
          <Switch
            className={styles.switch}
            onChange={(value) => {
              onUploadedFileRemove?.(value);
            }}
            value={shouldRemove}
            disabled={shouldRemove}
            checkedChildren={<DeleteOutlined />}
          />
        </div>
      )}
    </Flex>
  );
};

export default UploadedFile;
